var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"html-component",staticClass:"text-component"},_vm._l((_vm.payload.textBlocks),function(block,key){return _c('div',{key:key,class:[block.dimension, block.alignment],domProps:{"innerHTML":_vm._s(block.text)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }